import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card shadow-sm mb-4" }
const _hoisted_2 = { class: "card-content p-2" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = { class: "row visit-card" }
const _hoisted_7 = { class: "col-10" }
const _hoisted_8 = { class: "border-end time-slot float-start pt-3 me-2" }
const _hoisted_9 = { class: "text-secondary fw-bold" }
const _hoisted_10 = { class: "text-primary fw-bold" }
const _hoisted_11 = { class: "overflow-hidden mobile-visit-card" }
const _hoisted_12 = { class: "fw-bold text-secondary lh-normal mb-1" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 2 }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "text-center pt-3"
}
const _hoisted_18 = {
  key: 1,
  class: "loading-card-area"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_pagination = _resolveComponent("lazy-pagination")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "card-header text-white bg-secondary fw-bold" }, "Completed Training Sessions", -1)),
    _createElementVNode("div", _hoisted_2, [
      (!_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (Object.keys(_ctx.props.completed_training_sessions).length)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.completed_training_sessions, (training_session) => {
                    return (_openBlock(), _createElementBlock("a", {
                      href: '/#/training/' + training_session.id,
                      key: training_session.id,
                      class: "col-12 d-block visit-card-anchor",
                      onClick: ($event: any) => (_ctx.router.push({name:'training',params:{training_session_id:training_session.id}}))
                    }, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "rounded-circle float-start me-2 icon-circle" }, [
                            _createElementVNode("i", { class: "fas fa-chalkboard-teacher mx-auto" })
                          ], -1)),
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.moment(training_session.utc_time || training_session.local_time).format('MM/DD/YY')), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "my-1" }, null, -1)),
                            _createElementVNode("span", _hoisted_10, [
                              _createTextVNode(_toDisplayString(_ctx.moment(training_session.utc_time || training_session.local_time).format('h:mm')), 1),
                              _createElementVNode("sup", null, _toDisplayString(_ctx.moment(training_session.utc_time || training_session.local_time).format('a')), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              (training_session.training_session_type_id == _ctx.TrainingSessionType.ONBOARDING)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, "On-Boarding"))
                                : (training_session.scenario !== null)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(training_session.scenario.title), 1))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_15, "Scenario"))
                            ]),
                            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "mb-2" }, [
                              _createElementVNode("strong", null, "Trainer")
                            ], -1)),
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(training_session.trainer.first_name) + " " + _toDisplayString(training_session.trainer.last_name), 1),
                              _cache[1] || (_cache[1] = _createElementVNode("br", null, null, -1)),
                              _createElementVNode("small", null, _toDisplayString(training_session.trainer.email), 1)
                            ]),
                            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                            (_ctx.is_trainer)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-2" }, [
                                    _createElementVNode("strong", null, "Participants")
                                  ], -1)),
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(training_session.sp_users, (sp_user) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      key: sp_user.id,
                                      class: "mb-3"
                                    }, [
                                      _createElementVNode("div", null, _toDisplayString(sp_user.user.first_name) + " " + _toDisplayString(sp_user.user.last_name), 1),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("small", null, _toDisplayString(sp_user.user.email), 1)
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-2 d-flex flex-column justify-content-center" }, [
                          _createElementVNode("h3", { class: "text-center" }, [
                            _createElementVNode("i", { class: "fas fa-check text-primary" })
                          ])
                        ], -1))
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("hr", { class: "w-75" }, null, -1))
                    ], 8, _hoisted_5))
                  }), 128)),
                  (_ctx.props.completed_training_sessions_total > 10)
                    ? (_openBlock(), _createBlock(_component_lazy_pagination, {
                        key: 0,
                        items: _ctx.props.completed_training_sessions,
                        total: _ctx.props.completed_training_sessions_total,
                        page_start: _ctx.page_start,
                        page_end: _ctx.page_end,
                        onNextPage: _ctx.nextPage,
                        onPreviousPage: _ctx.previousPage,
                        label: 'Training Sessions'
                      }, null, 8, ["items", "total", "page_start", "page_end", "onNextPage", "onPreviousPage"]))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("p", _hoisted_17, "No Completed Training Sessions"))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_loading, {
              active: _ctx.loading,
              "is-full-page": false
            }, null, 8, ["active"])
          ]))
    ])
  ]))
}